import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { IdleService } from '../../../services/idle.service';
import { NgIf } from '@angular/common';
import { deleteAllCookie } from '../../security/cookies';
import { Router } from '@angular/router';

@Component({
  selector: 'app-idle-warning',
  imports: [NgIf],
  templateUrl: './idle-warning.component.html',
  styleUrl: './idle-warning.component.scss',
})
export class IdleWarningComponent implements OnInit, OnDestroy {
  showWarning = false;
  countdown = 120; // 120 seconds
  private subscription: Subscription = new Subscription();
  private countdownInterval: any;

  constructor(
    private idleService: IdleService,
    private router: Router,
  ) {}

  ngOnInit() {
    const isSignIn = this.router.url.includes('sign-in');

    if (!isSignIn) {
      this.subscription.add(
        this.idleService.showWarning.subscribe((show) => {
          this.showWarning = show;
          if (show) {
            this.startCountdown();
          } else {
            this.stopCountdown();
          }
        }),
      );
    }
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
    this.stopCountdown();
  }

  extendSession() {
    this.idleService.extendSession();
  }

  logout() {
    // Trigger immediate logout
    localStorage.clear();
    deleteAllCookie();
    sessionStorage.clear();
    window.location.href = '/sign-in';
  }

  private startCountdown() {
    this.countdown = 120;
    this.countdownInterval = setInterval(() => {
      this.countdown--;
      if (this.countdown <= 0) {
        this.stopCountdown();
      }
    }, 1000);
  }

  private stopCountdown() {
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
    }
  }
}
